<template>
  <div class="langmuir-probe-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>I = I_sat [1 - exp(e(V-V_p)/kT)] | 伏安特性$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Plasma background -->
          <rect width="400" height="240" fill="rgba(88, 51, 255, 0.05)" />
          <circle v-for="n in 20" :key="n" :cx="Math.random()*400" :cy="Math.random()*240" r="1" fill="#fff" opacity="0.4">
             <animate attributeName="opacity" values="0.2;0.8;0.2" :dur="Math.random()+1+'s'" repeatCount="indefinite" />
          </circle>

          <!-- The Probe -->
          <g transform="translate(150, 120)">
             <rect x="0" y="-2" width="60" height="4" fill="#aaa" /> <!-- Support -->
             <circle cx="60" cy="0" r="4" fill="#ffd700" stroke="#fff" /> <!-- Tip -->
             
             <!-- Sheath visualization (Darker region around tip) -->
             <circle v-if="bias < 0" cx="60" cy="0" :r="8 + Math.abs(bias)/5" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="2" />
          </g>

          <!-- The Graph (I-V curve) -->
          <g transform="translate(250, 180)">
             <line x1="0" y1="0" x2="120" y2="0" stroke="#888" /> <!-- V axis -->
             <line x1="60" y1="20" x2="60" y2="-100" stroke="#888" /> <!-- I axis -->
             
             <!-- The Curve -->
             <path :d="ivCurvePath" fill="none" stroke="#00d2ff" stroke-width="2" />
             
             <!-- Current bias point -->
             <circle :cx="60 + bias" :cy="-currentY" r="4" fill="#ff4757" />
             
             <text x="120" y="10" fill="#888" font-size="8">电压 V</text>
             <text x="40" y="-100" fill="#888" font-size="8">电流 I</text>
          </g>

          <text x="50" y="55" fill="#5833ff" font-size="8">等离子体区</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>探针偏压: {{ bias.toFixed(1) }} V</label>
              <div class="value" style="color: #00d2ff">区段: {{ region }}</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>扫描偏压</label>
             <el-slider v-model="bias" :min="-60" :max="60" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>朗缪尔探针是在等离子体诊断中最常用的工具。通过向插入等离子体的金属丝施加可变偏压并测量电流，可以得到**伏安特性曲线**。当偏压极负时，测量到的是离子饱和电流；偏压增加到一定程度（等离子体电势），电子大量流入。通过分析曲线的斜率和转折点，物理学家可以计算出等离子体的**电子温度**和**电子密度**。这是理解核聚变、等离子体刻蚀及空间物理的基本手段。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LangmuirProbeViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      bias: -30
    }
  },
  computed: {
    region() {
       if (this.bias < -40) return "离子饱和区";
       if (this.bias < 10) return "过渡区/电子延迟区";
       return "电子饱和区";
    },
    currentY() {
       // Typical IV curve shape: I = I_sat * (1 - exp(-(V-Vf)/Te))
       let Vf = -10;
       let Te = 15;
       let Isat = 20;
       let val = Isat * (1 - Math.exp((this.bias - Vf) / Te));
       return val;
    },
    ivCurvePath() {
       let points = [];
       let Vf = -10;
       let Te = 15;
       let Isat = 20;
       for (let v = -60; v <= 50; v += 2) {
          let i = Isat * (1 - Math.exp((v - Vf) / Te));
          points.push(`${60 + v},${-i}`);
       }
       return "M " + points.join(" L ");
    }
  }
}
</script>

<style scoped lang="scss">
.langmuir-probe-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(88, 51, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
